






















































import { Vue, Prop, Component } from "vue-property-decorator"

import RecipeHeader from "@/components/BaseComponents/RecipeHeader.vue"

@Component({
	components: {
		RecipeHeader
	}
})
export default class PreparationsOverview extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;
	numberOfPortions = 1;

	toHoursAndMinutes(minutes: number) {
		if (minutes % 60 === 0) {
			return minutes / 60 + " time(r) "
		} else if (minutes / 60 < 1) {
			return (minutes % 60) + " min"
		}
		return Math.floor(minutes / 60) + " time(r) " + (minutes % 60) + " min"
	}

	get hasPassivePrepTime() {
		// @ts-ignore
		return (this.recipe.preparationtime.passive !== "" && parseInt(this.recipe.preparationtime.passive) > 0)
	}

	get totalCookTime() {
		// @ts-ignore
		return this.toHoursAndMinutes(Number(this.recipe.preparationtime.active) + Number(this.recipe.preparationtime.passive))
	}

	get activePrepTime() {
		// @ts-ignore
		return this.toHoursAndMinutes(Number(this.recipe.preparationtime.active))
	}

	get passivePrepTime() {
		// @ts-ignore
		return this.toHoursAndMinutes(Number(this.recipe.preparationtime.passive))
	}

	get hasServings() {
		return "servings" in this.recipe && this.recipe.servings
	}

	get hasServingsWithType() {
		return "servings_w_type" in this.recipe && this.recipe.servings_w_type
	}

	get hasPrepTime() {
		return "preparationtime" in this.recipe && this.recipe.preparationtime
	}

	get portionScaling(): number[] {
		return [0.25, 0.5, 0.75, 1, 1.5].concat(
			Array(10)
				.fill(2)
				.map((x, y) => x + y)
		)
	}
}
